import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { AdminLoginEnhanced as AdminLogin } from '@grcs/views/Auth/AdminLogin.enhanced';
import { StudentLoginEnhanced as StudentLogin } from '@grcs/views/Auth/StudentLogin.enhanced';
import { SignUpPageEnhanced as SignUpPage } from '@grcs/views/Auth/SignUpPage.enhanced';

export const AuthRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="admin-login" element={<AdminLogin />} />
      <Route path="student-login" element={<StudentLogin />} />
      <Route path="signup" element={<SignUpPage />} />
      <Route path="register" element={<SignUpPage />} />
    </Routes>
  );
};
